module.exports = __webpack_public_path__ + "static/media/ionic.f106a1ac.png";